export default function (state, value, filter) {
    filter = filter ? filter : state.filter;
    let form = state.filters.filter(i => {
        return i.id === filter;
    })[0];
    if (!form) return;
    for (let k in value) {
        if (typeof form[k] !== 'undefined') form[k] = value[k];
    }
}